import { render, staticRenderFns } from "./SuscripcionesPrecio.vue?vue&type=template&id=17666076&"
import script from "./SuscripcionesPrecio.vue?vue&type=script&lang=js&"
export * from "./SuscripcionesPrecio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports